import { FoodRunningOutNotificationEdit } from '../components/FoodRunningOutNotification/FoodRunningOutNotificationEdit';

export const FoodRunningOutNotifications = {
  edit: FoodRunningOutNotificationEdit
};